// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"06d3ed13","703":"7ad18071"}[chunkId] + ".chunk.js";
};